export const Colors = {
  // Primary colors
  SecondaryColor: "#64DFFF",
  White: "#FFFFFF",
  Black: "#000000",

  // Background colors
  bgDrawerMobile:
    "linear-gradient(180deg, rgba(14, 6, 39, 0.95) 0%, rgba(26, 19, 51, 0.95) 100%)",
  bgCategoryDefault: "linear-gradient(90deg, #0E0627, #27213C)",
  bgMenuButton: "rgba(14, 6, 39, 0.8)",
  bgCloseButton: "rgba(14, 6, 39, 0.9)",

  // Overlay colors
  overlayDark: "rgba(0, 0, 0, 0.5)",

  // Border colors
  borderDefault: "#403B4A",
  borderActive: "rgba(100, 223, 255, 0.5)",
  borderMenuButton: "rgba(100, 223, 255, 0.3)",
  borderCard: "rgba(226, 226, 226, 0.6)",

  // State colors
  activeBackground: "rgba(100, 223, 255, 0.5)",

  // Text colors
  textGray: "#939393",

  // Component specific
  cardBackground: "#1C1C1C",
} as const;

// Export type for type safety
export type ColorKey = keyof typeof Colors;
